import Model from "./Model";

export default class extends Model {
    async loadTable(device_id,)
    {
        let response = await axios.get(this.urls.get, {
            params: {
                device_id,
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
        };

        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(
              history => {
                  let telem = {
                      tbody: {}
                  };
                  telem.tbody.created_at = history.created_at;
                  telem.tbody.title = history.title;
                  telem.tbody.number = history.number;
                  telem.tbody.street = history.street;
                  telem.tbody.name = history.name;

                  result.tbody.push(telem);
            });
        }
        return result;
    }
}
